import React, { useEffect, useState } from "react";

const SECTIONS = [
  { id: "hero",            label: "Indító" },
  { id: "szolgaltatasok",  label: "Munkák" },
  { id: "garanciak",       label: "Garanciák" },
  { id: "referenciak",     label: "Referenciák" },
  { id: "rolam",           label: "Rólunk" },
  { id: "kapcsolat",       label: "Kapcsolat" },
];

export default function ScrollRail() {
  const [active, setActive] = useState("hero");

  useEffect(() => {
    const onScroll = () => {
      const mid = window.scrollY + window.innerHeight * 0.35;
      let current = "hero";
      for (const s of SECTIONS) {
        const el = document.getElementById(s.id);
        if (el && el.offsetTop <= mid) current = s.id;
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const jump = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="rail" data-testid="scroll-rail" aria-hidden>
      {SECTIONS.map((s) => (
        <button
          key={s.id}
          onClick={() => jump(s.id)}
          aria-label={s.label}
          className={`rail-dot ${active === s.id ? "active" : ""}`}
          data-testid={`rail-${s.id}`}
        >
          <span className="rail-tip">{s.label}</span>
        </button>
      ))}
    </div>
  );
}
